<ng-container *ngFor="let facet of facets | slice:0:showFacets">
  <app-facet [facet]="facet" [is-applied]="isApplied(facet)" (facetToggled)="toggled($event)"></app-facet>
</ng-container>

  <div [@slideInOut]="open">
    <app-facet *ngFor="let facet of facets | slice:showFacets" [facet]="facet" [is-applied]="isApplied(facet)" (facetToggled)="toggled($event)"></app-facet>
  </div>

  <div class="show-more" *ngIf="hasMoreFacets" (click)="showMore()">
    <span class="text">{{ (open ? 'catalog.showless' : 'catalog.showmore') | translate }}</span>
    <i class="fa" [ngClass]="{'fa-chevron-up': open, 'fa-chevron-down': !open}"></i>
  </div>
